module.exports = __webpack_public_path__ + "img/cuff length.c2f6ec3e.png";